import { render } from "./OrderViewKiosk.vue?vue&type=template&id=fc6a8e2c&scoped=true"
import script from "./OrderViewKiosk.vue?vue&type=script&lang=js"
export * from "./OrderViewKiosk.vue?vue&type=script&lang=js"

import "./OrderViewKiosk.vue?vue&type=style&index=0&id=fc6a8e2c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc6a8e2c"]])

export default __exports__